import * as React from "react";

import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    PasswordInput,
    useNotify,
    useRefresh,
    useRedirect,
   
} from "react-admin";

const validateAdminUpdate = (values) => {
    const errors = {};
    if (values.password !== values.confirmPassword) {
        errors.password = "Passwords do not match";
        errors.confirmPassword = "Passwords do not match";
    }

    return errors;
};




export const AdminEdit = (props) => {
    const notify = useNotify();
    const refresh = useRefresh();
    const redirect = useRedirect();

    const onSuccess = (data) => {
        notify(`Changes saved`);
        redirect("/categories");
        refresh();
    };

    const onFailure = (error) => {
        notify(`Could not edit Admin: ${error.message}`);
        refresh();
    };

    return (
        <Edit mutationMode="pessimistic" undoable={false} onSuccess={onSuccess} onFailure={onFailure} {...props}>
            <SimpleForm validate={validateAdminUpdate}>
                <>
                    <div className="Admin_feild">
                        <h2>Add New Admin</h2>
                        <TextInput size="medium" label="admin_name" source="admin_name" validate={requiredValidate} />

                        <div className="admin-2">
                            <PasswordInput size="medium" label="Password" source="password" validate={requiredValidate} />
                            <PasswordInput size="medium" label="Confirm Password" source="confirmPassword" validate={requiredValidate} />
                        </div>
                    </div>
                </>
            </SimpleForm>
        </Edit>
    );
};


const requiredValidate = [required()];
